import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { officeReady } from './services/office/officeReady';
import { installGlobalHandlers, flushPending, registerAppStateProvider } from './services/errors/errorReporter';
import { useSelectionStore } from './stores/selectionStore';
import { useTreeStore } from './stores/treeStore';
import { useUiStore } from './stores/uiStore';

installGlobalHandlers();
registerAppStateProvider(() => ({
  selectionCount: useSelectionStore.getState().items.length,
  activeContainerId: useTreeStore.getState().activeContainerId,
  activeFolderId: useTreeStore.getState().activeFolderId,
  view: useUiStore.getState().view,
  modalOpen: useUiStore.getState().modalOpen,
}));
void flushPending();

// Render immediately. We used to gate the whole render on Office.onReady,
// which meant a slow/never-firing Office.onReady (seen in the pinned task
// pane after a refresh) left the panel fully blank with no spinner. Office
// readiness is handled inside OfficeProvider; warm the promise here so it's
// cached, but never block the first paint on it.
void officeReady();
const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
